<template>
  <section v-if="slides && slides.length > 0" class="q-hero-slider">
    <Splide :options="splideOptions">
      <SplideSlide v-for="(slide, i) in slides" :key="i" class="q-hero-slide">
        <img :src="slide" :alt="'Slide ' + (i + 1)" class="q-hero-img" />
      </SplideSlide>
    </Splide>
  </section>
</template>

<script>
import { Splide, SplideSlide } from "@splidejs/vue-splide";

export default {
  name: "HomeSlider",
  components: { Splide, SplideSlide },
  props: ["slides"],
  data() {
    return {
      splideOptions: {
        type:       "loop",
        autoplay:   true,
        interval:   4000,
        speed:      900,
        arrows:     true,
        pagination: true,
        pauseOnHover: true,
      },
    };
  },
};
</script>

<style>
/* Splide overrides for hero */
.q-hero-slider .splide__arrow {
  background: rgba(13, 15, 20, 0.55);
  border: 1px solid rgba(255,255,255,0.1);
  backdrop-filter: blur(4px);
  width: 40px; height: 40px;
  opacity: 1;
  transition: all var(--q-transition);
}
.q-hero-slider .splide__arrow:hover { background: var(--primary-color); border-color: var(--primary-color); }
.q-hero-slider .splide__arrow svg { fill: #fff; }
.q-hero-slider .splide__arrow:hover svg { fill: #ffffff; }

.q-hero-slider .splide__pagination { bottom: 12px; }
.q-hero-slider .splide__pagination__page {
  background: rgba(255,255,255,0.4);
  width: 8px; height: 8px;
  margin: 0 3px;
  transition: all var(--q-transition);
}
.q-hero-slider .splide__pagination__page.is-active {
  background: var(--primary-color);
  transform: scale(1.3);
}
</style>

<style scoped>
.q-hero-slider {
  width: 100%;
  max-width: 1230px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  padding-bottom: 40px;
}

.q-hero-slide {
  width: 100%;
  height: 100%;
}
.q-hero-img {
  width: 100%;
  height: 47vh;
  display: block;
  object-fit: cover;
  object-position: center;
}

@media (max-width: 768px) {
  .q-hero-img {
    width: 100%;
    height: 23vh;
  }
  .q-hero-slider {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  overflow: visible;
  padding: 0;
}
}
</style>
